<template>
  <div>
    <div class="nav-vertical">
      <ul class="nav nav-tabs nav-left" role="tablist">
        <li class="nav-item">
          <a
            class="nav-link active"
            v-bind:href="'#t1' + rowData.docfis_id + ''"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Ocorrências
              <i class="fa fa-doc"></i>
            </span>
          </a>
        </li>
      </ul>
      <div class="tab-content">
        <div
          role="tabpanel"
          class="tab-pane fade in active show"
          v-bind:id="'t1' + rowData.docfis_id + ''"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 5%">Código</th>
                <th style="width: 15%">Ocorrência</th>
                <th style="width: 15%">Data da Ocorrência</th>
                <th style="width: 15%">Usuario Inc.Ocorrência</th>
                <th style="width: 15%">Obs.</th>
                <th style="width: 10%">Status Integração</th>
                <th style="width: 5%">Unidade</th>
                <th style="width: 15%">Dt.Canc.Ocorr.</th>
                <th style="width: 15%">Motivo Canc.</th>
                <th style="width: 15%">Usuario Canc.</th>
                <th style="width: 15%">Status Ocorrência</th>
                <th style="width: 15%">Foto</th>
                <th style="width: 10%">Ações</th>
              </tr>
            </thead>
            <tbody v-for="item in rowData.carga_ocorrencia">
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  {{ item.param_ocorrencia.cd }}
                </td>
                <td>
                  {{ item.param_ocorrencia.descr }}
                </td>
                <td>
                  {{ formatDate(item.dt_ocorrencia) }}
                </td>
                <td>
                  <span>
                    {{ obterNomeOuEmailDoUsuario(item) }}
                  </span>
                </td>
                <td>
                  {{ item.obs }}
                </td>
                <td>
                  <span
                    class="badge badge-success"
                    v-if="
                      item.status_integracao &&
                      item.status_integracao.valor == 1
                    "
                    >{{ item.status_integracao.descr }}</span
                  >
                  <span
                    class="badge badge-warning"
                    v-if="
                      item.status_integracao &&
                      item.status_integracao.valor == 2
                    "
                    >{{ item.status_integracao.descr }}</span
                  >
                  <!--
                    Ocorrencia anterior ao TMS-7218 nao tem motivo registrado
                    (motivo_integracao e motivo_integracao_label nulos) e nunca
                    sera preenchida retroativamente: nesse caso a celula exibe
                    apenas o badge, sem texto vazio nem "undefined" na tela.
                  -->
                  <template
                    v-if="
                      item.status_integracao &&
                      item.status_integracao.valor == 3
                    "
                  >
                    <span
                      class="badge badge-danger"
                      v-b-tooltip
                      :title="tituloMotivoIntegracao(item)"
                      >{{ item.status_integracao.descr }}</span
                    >
                    <small
                      class="d-block text-danger"
                      v-if="item.motivo_integracao_label"
                      v-b-tooltip
                      :title="tituloMotivoIntegracao(item)"
                      >{{ item.motivo_integracao_label }}</small
                    >
                  </template>
                </td>
                <td>
                  <span v-if="item.unidade != null">{{ item.unidade.cd }}</span>
                  <span
                    v-if="
                      item.unidade == null &&
                      item.carga != null &&
                      item.carga.origem_montagem_carga != 2
                    "
                    >{{ item.carga.carga_unidade.unidade.cd }}</span
                  >
                </td>
                <td>
                  <span v-if="item.carga_ocorrencia_cancelamento != null">
                    {{ formatDate(item.carga_ocorrencia_cancelamento.dt_inc) }}
                  </span>
                </td>
                <td>
                  <span v-if="item.carga_ocorrencia_cancelamento != null">
                    {{ item.carga_ocorrencia_cancelamento.param_motivo.descr }}
                  </span>
                </td>
                <td>
                  <span v-if="item.carga_ocorrencia_cancelamento != null">
                    {{ item.carga_ocorrencia_cancelamento.usuario_cancelamento.pessoa.pessoa_fisica.nome }}
                  </span>
                </td>
                <td>
                  <span class="badge badge-success" v-if="item.status == 1"
                    >Ativo</span
                  >
                  <span class="badge badge-danger" v-if="item.status == 2"
                    >Cancelada</span
                  >
                </td>
                <td>
                  <a
                    @click="onDetail(item.carocorren_id)"
                    v-b-tooltip
                    title="Ver fotos"
                    ><i class="fa fa-plus"></i
                  ></a>
                </td>
                <td>
                  <a
                    v-if="
                      getPermissionFw('inclusaoocorrencia.reenvio') &&
                      item.status_integracao &&
                      item.status_integracao.valor == 3 &&
                      item.reenvio_permitido !== false
                    "
                    @click="onReenvioErp(item.carocorren_id)"
                    v-b-tooltip
                    title="Reenviar Ocorrência"
                    ><i class="fa fa-reply"></i
                  ></a>
                  <!--
                    Reenvio indisponivel: a tela informa o porque em vez de
                    apenas omitir a acao. O bloqueio real e o 422 do endpoint.

                    A condicao e `=== false`, complemento exato do `!== false`
                    do link acima: sem o campo (backend anterior ao TMS-7218,
                    ou rollback do #3574) a tela volta a oferecer o reenvio como
                    antes, em vez de esconder a acao de toda ocorrencia em erro.

                    `tabindex`/`role`/`aria-*`: o <span> inerte nao e focavel e
                    o icone nao tem nome acessivel, entao sem isso o motivo so
                    existe no hover. O `tabindex` tambem faz o tooltip abrir no
                    foco, ja que o trigger default da diretiva e `hover focus`.
                  -->
                  <span
                    v-if="
                      getPermissionFw('inclusaoocorrencia.reenvio') &&
                      item.status_integracao &&
                      item.status_integracao.valor == 3 &&
                      item.reenvio_permitido === false
                    "
                    class="text-muted"
                    style="cursor: not-allowed"
                    tabindex="0"
                    role="button"
                    aria-disabled="true"
                    v-b-tooltip
                    :title="tituloReenvioIndisponivel(item)"
                    :aria-label="tituloReenvioIndisponivel(item)"
                    ><i class="fa fa-reply"></i
                  ></span>
                  <a
                    @click="inativarOcorrencia(item.carocorren_id)"
                    v-b-tooltip
                    title="Inativar Ocorrência"
                    ><i class="fa fa-thumbs-o-down"></i
                  ></a>
                </td>
              </tr>
              <tr v-if="isVisibleDetail(item.carocorren_id)">
                <td colspan="12">
                  <section class="tabs-section">
                    <ul
                      class="nav nav-tabs nav-topline nav-justified"
                      role="tablist"
                    >
                      <li class="nav-item">
                        <a
                            class="nav-link active"
                            v-bind:href="'#tr1' + item.carocorren_id + ''"
                            role="tab"
                            data-toggle="tab"
                        >
                          <span class="nav-link-in">
                            Dados Recebedor
                            <i class="fa fa-puser"></i>
                          </span>
                        </a>
                      </li>
                      <li class="nav-item">
                        <a
                          class="nav-link"
                          v-bind:href="'#tr2' + item.carocorren_id + ''"
                          role="tab"
                          data-toggle="tab"
                        >
                          <span class="nav-link-in">
                            Fotos
                            <i class="fa fa-picture-o"></i>
                          </span>
                        </a>
                      </li>
                    </ul>
                    <div class="tab-content">
                      <div
                          role="tabpanel"
                          class="tab-pane fade in active show pt-1 border-color-detalhes-grey"
                          v-bind:id="'tr1' + item.carocorren_id + ''"
                      >
                        <table
                            :class="['vuetable table table-striped tbl-typical']"
                        >
                          <thead>
                          <tr>
                            <th style="width: 25%">Nome</th>
                            <th style="width: 10%">Documento</th>
                            <th style="width: 10%">Tipo</th>
                            <th style="width: 10%">Latitude da baixa de entrega</th>
                            <th style="width: 10%">Longitude da baixa de entrega</th>
                            <th style="width: 10%">Indicador conforme/não confome ?</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr
                              class="bg-gray-light"
                              style="display: table-row"
                          >
                            <td>
                              {{ item.nome_recebedor}}
                            </td>
                            <td>
                              {{ item.doc_recebedor}}
                            </td>
                            <td>
                              {{ item.tp_recebedor}}
                            </td>
                            <td>
                              {{ item.entrega_lat}}
                            </td>
                            <td>
                              {{ item.entrega_lng}}
                            </td>
                            <td>
                              {{ item.audita_local_entrega}}
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                      <div
                        role="tabpanel"
                        class="tab-pane fade in pt-1 border-color-detalhes-grey"
                        v-bind:id="'tr2' + item.carocorren_id + ''"
                      >
                        <table
                          :class="['vuetable table table-striped tbl-typical']"
                        >
                          <thead>
                            <tr>
                              <th style="width: 10%">N° da foto</th>
                              <th style="width: 35%">Link</th>
                            </tr>
                          </thead>
                          <tbody
                            v-for="(
                              item_itens, i
                            ) in item.carga_ocorrencia_foto"
                          >
                            <tr
                              class="bg-gray-light"
                              style="display: table-row"
                            >
                              <td>
                                {{ i + 1 }}
                              </td>
                              <td>
                                <a
                                  @click="goLink(item_itens.url_foto)"
                                  target="_blank"
                                  >{{ item_itens.nome_foto }}</a
                                >
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </section>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
      </div>
      <!--.tab-content-->
      <InclusaoOcorrenciaInativarForm ref="inclusaoocorrenciainativarform" />
    </div>
  </div>
</template>

  <script>
import moment from "moment";
import InclusaoOcorrenciaInativarForm from "./InclusaoOcorrenciaInativarForm.vue";

import { formatCNPJFromParts } from "../utils";

export default {
  components: {
    InclusaoOcorrenciaInativarForm,
  },
  data() {
    return {
      helpForm: new Form({
        recordCollection: [],
        status: "",
        carocorren_id: "",
      }),
      cnpj_formatado: "",
      visibleDetailRows: [],
      // Atribuido por ReturnApi. Sem declarar aqui nao e reativo e as
      // atribuicoes ficam silenciosamente inuteis.
      errors_array: [],
    };
  },
  created() {
    // OVERRIDE-FORM-ONFAIL (TMS-7218)
    // `Form.submit` rejeita apenas o `errors` do envelope quando `type == 3`
    // (Form.js), e o 422 do reenvio traz `errors` vazio: a `message` morreria
    // antes de chegar ao operador. `onFail` e o ponto de extensao da classe
    // Form e recebe o envelope completo, entao e por ele que a mensagem sai.
    //
    // Acoplamento com a TMS-6598: se o conserto do `Form.js` passar a
    // notificar o usuario centralmente, esta view exibira a mensagem do 422
    // duas vezes e nao ha teste no repo que pegue. Ao mexer em `Form.onFail`,
    // grepe por OVERRIDE-FORM-ONFAIL antes.
    const helpForm = this.helpForm;
    const onFailOriginal = helpForm.onFail.bind(helpForm);

    helpForm.onFail = (envelope) => {
      onFailOriginal(envelope);
      this.notificaRetorno(envelope);
    };
  },
  props: {
    rowData: {
      type: Object,
      required: true,
    },
    rowIndex: {
      type: Number,
    },
  },
  methods: {
    obterNomeOuEmailDoUsuario(cargaOcorrencia) {
      const CTE_CANCELADO = 30

      const strategy = {
        ocorrencia: cargaOcorrencia.param_ocorrencia ? {
          codigo: cargaOcorrencia.param_ocorrencia.cd
        } : null,
        usuarioCancelamento: cargaOcorrencia.doc && cargaOcorrencia.doc.usuario_canc ? {
          email: cargaOcorrencia.doc.usuario_canc.email,
          nome : cargaOcorrencia.doc.usuario_canc.pessoa ? cargaOcorrencia.doc.usuario_canc.pessoa.pessoa_fisica.nome : null
        } : null,
        usuarioIncluido: cargaOcorrencia.usuario_inc ? {
          email: cargaOcorrencia.usuario_inc.email,
          nome : cargaOcorrencia.usuario_inc.pessoa ? cargaOcorrencia.usuario_inc.pessoa.pessoa_fisica.nome : null
        } : null
      };

      if(strategy.ocorrencia.codigo == CTE_CANCELADO && strategy.usuarioCancelamento) {
        return strategy.usuarioCancelamento.nome || strategy.usuarioCancelamento.email;
      }

      return strategy.usuarioIncluido.nome || strategy.usuarioIncluido.email;
    },
        onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      return formatCNPJFromParts(cnpj_base, cnpj_filial, cnpj_digito);
    },
    DateFormat: function (date) {
      if (date != null) {
        return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
      }
      return "";
    },
    formatDate(value, fmt = "D/MM/YYYY HH:mm") {
      return value == null ? "" : moment(value, "YYYY-MM-DD HH:mm").format(fmt);
    },
    onActivateDesactivate(action, data, tipo) {
      // Tipo = true = Checkbox
      this.helpForm.status = action;
      if (tipo) {
        this.helpForm.recordCollection = [];
        this.helpForm.recordCollection.push(data.unidoc_id);
      } else {
        this.helpForm.recordCollection = [];
        this.$refs.vuetable.selectedTo.forEach((obj) => {
          this.helpForm.recordCollection.push(obj);
        });
      }
      this.$refs.vinculardocumentounidadeform.onActivateDesactivate(
        this.helpForm
      );
    },
    inativarOcorrencia(data) {
      this.$refs.inclusaoocorrenciainativarform.onCreate(data);
    },
    ajustaMascara(data) {
      if (data != null) {
        if (data.length == 11) {
          //cpf
          return data.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
        }
        if (data.length == 14) {
          //cnpj
          return data.replace(
            /([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})([A-Z0-9]{2})/,
            "$1.$2.$3/$4-$5"
          );
        }
      }
    },
    tituloMotivoIntegracao(item) {
      return item.motivo_integracao || item.motivo_integracao_label || "";
    },
    tituloReenvioIndisponivel(item) {
      const motivo =
        item.motivo_integracao_label ||
        item.motivo_integracao ||
        "esta ocorrência entrou em erro antes do registro do motivo da falha";

      return (
        "Reenvio indisponível: " +
        motivo +
        ". Reenviar não altera esta falha — a causa precisa ser corrigida antes de uma nova tentativa."
      );
    },
    notificaRetorno(envelope) {
      if (!envelope || !envelope.message) {
        return;
      }

      // Whitelist em vez de `this.$snotify[tp_message]`: o valor vem do
      // backend e indexar o objeto direto aceitaria herdados de
      // `Object.prototype` (`tp_message: "toString"` passaria no teste).
      const TIPOS_VALIDOS = ["success", "info", "warning", "error"];
      const tipo =
        TIPOS_VALIDOS.indexOf(envelope.tp_message) !== -1
          ? envelope.tp_message
          : "warning";

      this.$snotify[tipo](envelope.message, envelope.title || "");
    },
    onReenvioErp(id) {
      this.helpForm.carocorren_id = id;
      this.helpForm
        .patch("/api/inclusaoocorrencia/reenvio")
        .then((response) => {
          // `refresh = false`: o recarregamento da grid e feito pelo evento
          // abaixo, e nao pela varredura de `$parent` do ReturnApi.
          new ReturnApi(response, this, true, false, false);
          // A ref `vuetable` vive no componente pai; este detail row e
          // renderizado pelo Vuetable via `<component :is>`, sem listener,
          // entao `$emit` nao chega ao pai. O barramento `vue-events` e o
          // mecanismo ja usado no repo para recarregar a grid.
          this.$events.fire("inclusaoocorrencia-reload");
        })
        .catch((errors) => {
          this.errors_array = [];

          // Quando `type == 3` o Form rejeita a string vazia do campo `errors`
          // e a mensagem ja foi exibida por `notificaRetorno`. Chamar o
          // ReturnApi com um valor primitivo lancaria TypeError.
          if (!errors || typeof errors !== "object") {
            return;
          }

          new ReturnApi(errors, this, true, false, false, false);

          for (var property in errors) {
            if (Object.prototype.hasOwnProperty.call(errors, property)) {
              if (Array.isArray(errors[property])) {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onDetail(carocorren_id) {
      this.toggleDetail(carocorren_id);
    },
    isVisibleDetail(rowId) {
      return this.visibleDetailRows.indexOf(rowId) >= 0;
    },
    showDetail(rowId) {
      if (!this.isVisibleDetail(rowId)) {
        this.visibleDetailRows.push(rowId);
      }
    },
    hideDetail(rowId) {
      if (this.isVisibleDetail(rowId)) {
        this.visibleDetailRows.splice(this.visibleDetailRows.indexOf(rowId), 1);
      }
    },
    toggleDetail(rowId) {
      if (this.isVisibleDetail(rowId)) {
        this.hideDetail(rowId);
      } else {
        this.showDetail(rowId);
      }
    },
    formatDate(value, fmt = 'DD/MM/YYYY HH:mm') {
      return value == null ? "" : moment(value, "YYYY/MM/DD HH:mm").format(fmt);
    },
    goLink(data) {
      window.open(data, "_blank", "noopener");
    },
  },
};
</script>